import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { FleetReportDvcrService } from '../../../services/fleet-report-dvcr.service';
import { CommonService } from '../../../services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { GenericComponent } from '../../../model/reports';

interface SeverityDamageList {
  title?: string;
  content?: string[];
  style: object;
  textFieldData: { [key: string]: string } | null;
}

interface SeverityMoreDetailsInput {
  preTripComment: string | null;
  postTripComment: string | null;
  preDamageLists: SeverityDamageList[];
  postDamageLists: SeverityDamageList[];
  zipPathPre: any;
  zipPathPost: any;
  timeStampPre: any;
  timeStampPost: any;
  same?: boolean;
  version?: string;
  floatingDvirComment: string | null;
  floatingDvirDamageLists: SeverityDamageList[];
  zipPathFloatingDvir: any;
  timeStampFloatingDvir: any;
}

@Component({
  selector: 'vrm-custom-more-details-severity',
  templateUrl: './custom-more-details-severity.component.html',
  styleUrls: ['./custom-more-details-severity.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomMoreDetailsSeverityComponent implements GenericComponent, OnDestroy {
  @Input() public moreDetails: SeverityMoreDetailsInput;
  private getZipFileSubscription: Subscription;

  public constructor(
    private translate: TranslateService,
    private dvcrService: FleetReportDvcrService,
    private cService: CommonService
  ) {}

  public downloadZipFile(zipPath: string): void {
    this.getZipFileSubscription = this.dvcrService.getZip(zipPath).subscribe({
      next: (response) => {
        const link = document.createElement('a');
        link.href = `data:application/zip;base64,${response}`;
        link.download = 'images.zip';
        link.click();
        link.remove();
      },
      error: (error) => {
        console.log('ERROR', error);
        this.cService.showToast(this.cService.readyTranslations.messagesAndWarnings.genericError, null, 'close');
      },
    });
  }

  public getCategoryNameTranslationTag(moreDetails: SeverityMoreDetailsInput): string {
    if (moreDetails.version && moreDetails.version === 'DVCR_002') {
      return 'CATEGORY_NAMES_DVCR_002';
    }

    return 'CATEGORY_NAMES';
  }

  public getPredefinedCommentTranslationTag(moreDetails: SeverityMoreDetailsInput): string {
    if (moreDetails.version && moreDetails.version === 'DVCR_002') {
      return 'PREDEFINED_COMMENTS_TEXT_DVCR_002';
    }

    return 'PREDEFINED_COMMENTS_TEXT';
  }

  public get hasStandaloneComments(): boolean {
    const hasNoDamages = !this.moreDetails.postDamageLists.length && !this.moreDetails.preDamageLists.length;
    const hasComments = this.moreDetails.preTripComment || this.moreDetails.postTripComment;

    return hasComments && hasNoDamages;
  }

  public ngOnDestroy(): void {
    if (this.getZipFileSubscription) {
      this.getZipFileSubscription.unsubscribe();
    }
  }
}
